import { storage } from '../components/Firebase';

/**
 * Uploads a commercial license file to Firebase Storage
 * @param {File} file - The file to upload
 * @param {string} companyName - The company name to use in the file path
 * @returns {Promise<string>} - The download URL of the uploaded file
 */
export async function uploadCommercialLicenseToStorage(file, companyName) {
  try {
    // Get file extension
    const ext = file.name.split('.').pop() || 'pdf';
    
    // Create a sanitized company name for the path (remove special characters)
    const sanitizedCompanyName = companyName.replace(/[^a-zA-Z0-9]/g, '_');
    
    // Create a unique filename with timestamp
    const filename = `${Date.now()}_${sanitizedCompanyName}.${ext}`;
    
    // Create storage reference
    const storageRef = storage.ref(`commercialLicenses/${filename}`);
    
    // Upload the file
    const snapshot = await storageRef.put(file);
    
    // Get the download URL
    const downloadURL = await snapshot.ref.getDownloadURL();
    
    return downloadURL;
  } catch (error) {
    console.error('Error uploading commercial license:', error);
    throw new Error(`Failed to upload commercial license: ${error.message}`);
  }
}

